var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upload-button',{ref:"editor",attrs:{"options":_vm.options,"propInvisible":_vm.propInvisible,"propReadonly":_vm.readonly,"dataId":_vm.dataId,"validateArg":_vm.validateArg},on:{"change":_vm.changeHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }